import React, { useState, useEffect } from "react";
// import { Link } from "react-scroll";
import { Link } from "react-router-dom";

import LogoLight from "../assets/images/logo_dark_png.png";
import LogoDark from "../assets/images/logo_light_png.png";
import DownloadIcon from "../assets/images/down2.svg";

// import Typed from 'typed.js';
import { mainMenu } from "../constants/menu";

const Header = ({ home }) => {
  const [isOpen, setMenu] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [scrolled, setScrolled] = useState(false);
  // window.addEventListener("scroll", windowScroll);
  const toggleMenu = () => {
    setMenu(!isOpen);
  };
  useEffect(() => {
    window.addEventListener("scroll", windowScroll);

    return () => {
      window.removeEventListener("scroll", windowScroll);
    };
  }, []);

  // // setTimeout(() => {
  // //   new Typed("#typed", {
  // //     strings: [
  // //       "<b>Business</b>",
  // //       "<b>Startups</b>",
  // //       "<b>Digital Agency</b>",
  // //       "<b>Marketing</b>",
  // //     ],
  // //     backDelay: 2000,
  // //     loop: true,
  // //     startDelay: 300,
  // //     typeSpeed: 100,
  // //     backSpeed: 100,
  // //   });
  // // }, 500);

  // /**
  //  * Window scroll
  //  */
  function windowScroll() {
    const navbar = document.getElementById("navbar");
    if (
      document.body.scrollTop >= 50 ||
      document.documentElement.scrollTop >= 50
    ) {
      navbar.classList.add("is-sticky");
      setScrolled(true);
    } else {
      navbar.classList.remove("is-sticky");
      setScrolled(false);
    }
  }
  return (
    <nav className="navbar" id="navbar">
      <div className="container flex flex-wrap items-center justify-end">
        <a className="navbar-brand" href={"/"}>
          <span className="inline-block dark:hidden">
            {home ? (
              <>
                <img
                  src={LogoDark}
                  className="l-dark"
                  alt="The Green Space"
                  style={{ height: "70px", width: "100px" }}
                />
                <img
                  src={LogoLight}
                  className="l-light"
                  alt="The Green Space"
                  style={{ height: "70px", width: "100px" }}
                />
              </>
            ) : (
              <img
                src={LogoDark}
                className=""
                alt="The Green Space"
                style={{ height: "70px", width: "100px" }}
              />
            )}
          </span>
          {/* <img
                src={LogoLight}
                className="hidden dark:inline-block"
                alt=""
              /> */}
        </a>

        <div className="nav-icons flex items-center justify-end gap-1 flex-nowrap lg_992:order-2 ms-auto">
          <ul className="flex items-center gap-2 mb-0">
            {/* Phone */}
            <li>
              <a
                href="https://wa.me/8830552784"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="flex items-center justify-center w-10 h-10 rounded-full bg-white hover:bg-[#18443A] text-black hover:text-white transition">
                  <i className="uil uil-phone"></i>
                </span>
              </a>
            </li>

            {/* Email */}
            <li>
              <a href="mailto:info@greenspace.in">
                <span className="flex items-center justify-center w-10 h-10 rounded-full bg-white hover:bg-[#18443A] text-black hover:text-white transition">
                  <i className="uil uil-envelope"></i>
                </span>
              </a>
            </li>

            {/* Brochure Button */}
            <li>
              <a
                href="/brochure.pdf"
                download="GreenSpace-Brochure.pdf"
                className="flex items-center gap-1 h-9 px-3 bg-green-600 hover:bg-green-700 text-white text-xs md:text-sm font-medium rounded-md transition whitespace-nowrap"
              >
                <img src={DownloadIcon} alt="download" className="w-8 h-8" />
                Brochure
              </a>
            </li>

            {/* <li className="inline ms-1">
            <a href="https://www.instagram.com/_thegreenspace.in_/" target="_blank" rel="noopener noreferrer">
            <span className="login-btn-primary">
              <span className="btn btn-sm btn-icon rounded-full bg-white hover:bg-[#18443A] border-white text-black">
                <i className="uil uil-instagram"></i>
              </span>
            </span>
            <span className="login-btn-light">
              <span className="btn btn-sm btn-icon rounded-full bg-gray-50 hover:bg-[#18443A] dark:bg-slate-900 dark:hover:bg-gray-700 hover:border-gray-100 dark:border-gray-700 dark:hover:border-gray-700">
                <i className="uil uil-instagram"></i>
              </span>
            </span>
          </a>
         </li> */}
          </ul>
          <button
            type="button"
            className="collapse-btn inline-flex items-center ms-3 text-dark dark:text-white lg_992:hidden"
            onClick={toggleMenu}
          >
            <span className="sr-only">Navigation Menu</span>
            <i className="mdi mdi-menu mdi-24px"></i>
          </button>
        </div>

        <div
          className={`${
            isOpen === true ? "hidden" : "block"
          } navigation lg_992:order-1 lg_992:flex`}
          id="menu-collapse"
        >
          <ul
            className={`navbar-nav ${home ? "nav-light" : "nav-dark"}`}
            id="navbar-navlist"
          >
            {mainMenu.map((i, index) => (
              <Link to={i.href} className="nav-link">
                <li key={index} className="relative group list-none">
                  {i.submenu ? (
                    <span className="nav-link cursor-pointer">{i.title}</span>
                  ) : (
                    <Link to={i.href} className="nav-link">
                      {i.title}
                    </Link>
                  )}

                  {/* Dropdown */}
                  {i.submenu && (
                    <ul className="absolute left-0 top-full opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 bg-white shadow-md rounded-md z-50 "style={{color: "black"}}>
                      {i.submenu.map((sub, idx) => (
                        <li key={idx}>
                          <a
                            href={sub.href || "#"}
                            className="block px-4 py-2 text-sm hover:bg-gray-100 whitespace-nowrap"
                          >
                            {sub.title}
                          </a>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              </Link>
            ))}
            {/* <Link
                  className="nav-item"
                  activeclassname="active"
                  spy={true}
                  smooth={true}
                  duration={500}
                  to="about"
                >
                  <span className="nav-link">About us</span>
                </Link>
                <Link
                  className="nav-item"
                  to="features"
                  activeclassname="active"
                  spy={true}
                  smooth={true}
                  duration={500}
                >
                  <span className="nav-link">Services</span>
                </Link>
                <Link
                  className="nav-item"
                  to="portfolio"
                  activeclassname="active"
                  spy={true}
                  smooth={true}
                  duration={500}
                >
                  <span className="nav-link">Portfolio</span>
                </Link>
                <Link
                  className="nav-item"
                  to="testi"
                  activeclassname="active"
                  spy={true}
                  smooth={true}
                  duration={500}
                >
                  <span className="nav-link">Review</span>
                </Link> */}
            {/* <Link
                  className="nav-item"
                  to="pricing"
                  activeclassname="active"
                  spy={true}
                  smooth={true}
                  duration={500}
                >
                  <span className="nav-link">Pricing</span>
                </Link> */}
            {/* <Link
                  className="nav-item"
                  to="blog"
                  activeclassname="active"
                  spy={true}
                  smooth={true}
                  duration={500}
                >
                  <span className="nav-link">Blog</span>
                </Link>
                <Link
                  className="nav-item"
                  to="contact"
                  activeclassname="active"
                  spy={true}
                  smooth={true}
                  duration={500}
                >
                  <span className="nav-link">Contact us</span>
                </Link> */}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
